import loadable from '@loadable/component';

export const ReportsDetailGraphicConfigurationFilterEmployeeStageTitles = loadable(
  () => import('./ReportsDetailGraphicConfigurationFilterEmployeeStageTitles'),
);
